import "./RemotePairing.css";

import { useEffect, useState } from "react";
import QRCode from "qrcode";

type Props = {
  remoteUrl: string;
  sessionId: string;
  peerPresent: boolean;
  onClose: () => void;
};

export function RemotePairing({ remoteUrl, sessionId, peerPresent, onClose }: Props) {
  const [qrDataUrl, setQrDataUrl] = useState<string>("");
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    let alive = true;
    QRCode.toDataURL(remoteUrl, {
      margin: 1,
      width: 320,
      color: { dark: "#0b0f14", light: "#ffffff" },
    })
      .then((url) => {
        if (alive) setQrDataUrl(url);
      })
      .catch(() => {
        if (alive) setQrDataUrl("");
      });
    return () => {
      alive = false;
    };
  }, [remoteUrl]);

  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(remoteUrl);
      setCopied(true);
      window.setTimeout(() => setCopied(false), 1800);
    } catch {
      /* clipboard unavailable */
    }
  };

  return (
    <div className="remote-pairing" role="dialog" aria-label="Abbina telecomando">
      <div className="remote-pairing-card">
        <div className="remote-pairing-head">
          <h2>Telecomando</h2>
          <button
            type="button"
            className="surf-btn surf-btn--ghost"
            aria-label="Chiudi"
            onClick={onClose}
          >
            ×
          </button>
        </div>

        <p className="remote-pairing-hint">
          Inquadra il QR con il telefono (stesso account) per pilotare la presentazione.
        </p>

        <div className="remote-pairing-qr">
          {qrDataUrl ? (
            <img src={qrDataUrl} alt="QR telecomando" width={240} height={240} />
          ) : (
            <div className="remote-pairing-qr-placeholder" aria-hidden />
          )}
        </div>

        <div className="remote-pairing-actions">
          <button type="button" className="surf-btn" onClick={copyLink}>
            {copied ? "Link copiato" : "Copia link"}
          </button>
        </div>

        <details className="remote-pairing-fallback">
          <summary>Codice manuale</summary>
          <code className="remote-pairing-code">{sessionId}</code>
        </details>

        <div
          className={`remote-pairing-badge remote-pairing-badge--${peerPresent ? "on" : "off"}`}
          role="status"
        >
          {peerPresent ? "Telecomando connesso" : "In attesa del telecomando…"}
        </div>
      </div>
    </div>
  );
}
